module.exports = __webpack_public_path__ + "img/locker-bg.568bd154.svg";